<template>
    <div class="card">
        <div class="p-3 pb-0 card-header">
            <h6 class="mb-0">{{ cardTitle }}</h6>
            <p class="text-sm">Clientes que generaron mayor ingreso en el período.</p>
        </div>
        <div class="p-3 card-body">
            <ul class="list-group" :class="this.$store.state.isRTL ? 'pe-0' : ''">

                <li
                    v-for="(client, index) in getTopClients()"
                    :key="index"
                    class="mb-2 border-0 list-group-item d-flex justify-content-between border-radius-lg"
                    :class="this.$store.state.isRTL ? 'pe-0' : 'ps-0'"
                >
                    <div class="d-flex align-items-center">
                        <div
                            class="text-center shadow icon icon-shape icon-sm bg-success"
                            :class="this.$store.state.isRTL ? 'ms-3' : 'me-3'"
                        >
                            <i class="fa fa-user-tag text-white opacity-10"></i>
                        </div>
                        <div class="d-flex flex-column">
                            <h6 class="mb-1 text-sm text-dark">{{ client.client_name }}</h6>
                            <span class="text-xs">
                                NIT:
                                <span class="font-weight-bold">{{ client.client_nit }}</span>
                            </span>
                        </div>
                    </div>
                    <div class="d-flex">
                        <h6 class="mb-0 text-sm font-weight-bold text-success me-3">
                            {{ formatClientAmount(client.total_spent) }}
                        </h6>
                        <button
                            class="my-auto btn btn-link btn-icon-only btn-rounded btn-sm text-dark icon-move-right"
                        >
                            <i class="ni ni-bold-right" aria-hidden="true"></i>
                        </button>
                    </div>
                </li>
                <li v-if="!topClientsData.length" class="text-center border-0 list-group-item text-muted">
                    No hay suficientes datos de clientes para mostrar el ranking.
                </li>

            </ul>
        </div>
    </div>
</template>
<script>

import { formatCurrency } from '@/composables/useUtils';

export default {
    name: "categories-card",
    props: {
        cardTitle: {
            type: String,
            default: "Top Clientes",
        },
        topClientsData: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        formatClientAmount(amount) {
            // Asumiendo USD como moneda para el helper
            return formatCurrency(amount, 'USD', '$');
        },

        getTopClients(limit = 5) {
            // 🛑 CORRECCIÓN: Crear una copia superficial del array (usando spread [...]) 🛑
            const clientsCopy = [...this.topClientsData];

            return clientsCopy
                .sort((a, b) => parseFloat(b.total_spent) - parseFloat(a.total_spent))
                .slice(0, limit);
        }
    }
};
</script>
